import React, { forwardRef, useEffect, useImperativeHandle, useRef, } from 'react';
import { Animated, Platform, StyleSheet, TouchableWithoutFeedback, View, } from 'react-native';
import { useRem } from '../../hooks/useRem';
import { isWeb } from '../../utils/const';
import { parseSideSpace } from '../../utils/util';
import { animatedTo, getPostion } from './utils';
const styles = StyleSheet.create({
    wrap: {
        flex: 1,
        flexDirection: 'row',
        overflow: 'hidden',
        // @ts-ignore
        position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    },
});
const MaskDom = forwardRef((props, ref) => {
    var _a;
    const { duration = 150, maskZindex = 100, showMask = true, onPress, contentPosition = 'center', children, customStyle, opacity: targetOpacity = 0.3, sideSpace = 0, afterShow, afterClose, scalable, onAnimatedEnd, boxStyle, } = props;
    const { backgroundColor = '#000' } = customStyle || {};
    const opacity = (_a = useRef(new Animated.Value(0))) === null || _a === void 0 ? void 0 : _a.current;
    const getRem = useRem(scalable);
    const position = getPostion(contentPosition);
    const handleClose = () => {
        animatedTo({
            target: opacity,
            toValue: 0,
            duration,
            fn: () => {
                onAnimatedEnd && onAnimatedEnd();
                afterClose && afterClose();
            },
        });
    };
    useImperativeHandle(ref, () => ({
        close: handleClose,
    }));
    const handlePress = () => {
        onPress && onPress();
    };
    useEffect(() => {
        animatedTo({
            target: opacity,
            toValue: targetOpacity,
            duration,
            fn: afterShow,
        });
    }, []);
    return (React.createElement(View, Object.assign({ style: [
            StyleSheet.absoluteFill,
            styles.wrap,
            position,
            parseSideSpace({ sideSpace, getRem }),
            { zIndex: maskZindex },
            boxStyle,
        ], pointerEvents: showMask ? 'auto' : 'box-none', testID: "mask-wrap" }, (isWeb ? { className: 'mask_wrap_root' } : {})),
        showMask ? (React.createElement(TouchableWithoutFeedback, Object.assign({ onPress: handlePress, testID: "mask-dom" }, (isWeb ? { className: 'mask_dom_touch' } : {})),
            React.createElement(Animated.View, Object.assign({}, (isWeb ? { className: 'mask_dom_view' } : {}), { style: [
                    StyleSheet.absoluteFill,
                    { backgroundColor },
                    { opacity },
                ] })))) : null,
        children));
});
export default MaskDom;
